import { useState, forwardRef } from "react";
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  DialogContent,
  DialogActions,
  Button,
  Slide,
  Checkbox,
  FormControlLabel,
  Divider,
  Alert,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AutoPayConsentDialog = ({ open, onAgree, onCancel, paymentMethodType }) => {
  const [checked, setChecked] = useState(false);

  const handleClose = () => {
    setChecked(false);
    onCancel();
  };

  const handleAgree = () => {
    setChecked(false);
    onAgree();
  };

  const methodLabel =
    paymentMethodType === "us_bank_account" ? "ACH bank account" : "credit card";

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      <AppBar position="static">
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flex: 1 }}>
            Authorize Auto-Pay
          </Typography>
        </Toolbar>
      </AppBar>

      <DialogContent style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <Typography variant="body2" color="text.secondary">
          Please read and accept the authorization below to enable automatic payments.
        </Typography>

        <Divider />

        <Alert severity="info" icon={false}>
          <Typography variant="body2">
            By enabling auto-pay, you authorize <strong>Aisle 2 LLC</strong> to
            automatically charge your {methodLabel} on file for each invoice issued to
            your organization, approximately <strong>48 hours after the invoice is
            created</strong>. The amount charged will equal the total amount due on each
            invoice. You therefore have 48 hours from the time the invoice is created to dispute the charges.
            Invoices that are disputed will not be picked up by the auto-pay process.
          </Typography>
          <br />
          <Typography variant="body2">
            You may cancel this authorization at any time by disabling auto-pay from the
            invoice page. Cancellation will not affect any payments already scheduled.
          </Typography>
          <br />
          <Typography variant="body2">
            This authorization will remain in effect until you revoke it.
          </Typography>
        </Alert>

        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
            />
          }
          label={
            <Typography variant="body2">
              I have read and agree to the auto-pay authorization above.
            </Typography>
          }
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          variant="contained"
          disabled={!checked}
          onClick={handleAgree}
        >
          Agree &amp; Enable Auto-Pay
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AutoPayConsentDialog;
